import { MatchStrategy } from './base';

/**
 * Standard match strategy. Only match match the cache entry with exactly the
 * same key
 */
export class StandardMatchStrategy extends MatchStrategy {
  /**
   * Find a key/value pair matching the key according to the match strategies
   * @override
   * @param {ClientCacheManager} cacheManager - The client cache manager
   * @param {ClientCacheKey} key - The cache key
   * @returns {*} - The value matching the given key. Return null for no match.
   */
  match(cacheManager, key) {
    return cacheManager.get(key);
  }
}
